<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;

}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warehouse/purchase/detail/page"
      getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caigoudingdanhao')">
            <el-input v-model="yt.conditions.purchaserOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'"
              :ids.sync="yt.conditions.supplierIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('mingxizhuangtai')">
            <yi_dictionary_select :max="99" :multiple="true" :type="'WMS_PURCHASE_DETAIL_STATUS'" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_purchasing_management_purchase_order_release_issue')"
          @click="issue" type="primary">
          {{ $t('fabu') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_purchasing_management_purchase_order_release_revokeIssue')"
          @click="revokeIssue" type="primary">
          {{ $t('quxiaofabu') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()">
        </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_purchasing_management_purchase_order_release_list',
  data() {
    return {
      idList: [],
      issueData: [],
      columns: [{
        label: "xuanze",
        type: "selection",
        align: "center",
        selectable: (row, index) => true,
        width: 130,
      },
      {
        label: 'caigoudingdanhao',
        prop: 'purchaserOrderNo',
        width: 230
      }, {
        label: 'dingdanhanghao',
        prop: 'no',
        width: 230
      },
      {
        label: 'mingxizhuangtai',
        prop: 'status',
        type: 'dictionary_tag',
        key: 'WMS_PURCHASE_DETAIL_STATUS',
        width: 130
      },
      {
        label: 'wuliaobianma/mingcheng',
        prop: 'materialCodeAndName',
        width: 230
      },
      {
        label: 'dingdanshuliang',
        prop: 'quantity',
        width: 130
      },
      {
        label: 'caigoudanwei',
        prop: 'unit',
        width: 130
      },
      {
        label: 'dingdanjiaoqi',
        prop: 'deliveryTime',
        type: 'time',
        width: 130
      },
      {
        label: 'gongyingshangmingcheng',
        prop: 'supplierName',
        width: 130
      },
      {
        label: 'caigouyuan',
        prop: 'purchaserName',
        width: 130
      },
      {
        label: 'beizhu',
        prop: 'remark',
        width: 'auto'
      }],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300)
  },
  methods: {
    selectionChange(rows) {
      this.issueData = rows
    },
    //发布
    issue() {
      // 构建一个包含对象 ID 的数组
      let idsArray = this.issueData.map(item => item.id);
      // 发送 POST 请求给后端
      this.http.post('/web/warehouse/purchase/detail/issue', idsArray)
        .then((res) => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch((error) => {
          this.utils.errorMessage(this.$t(error))
        });
    },
    //发布
    revokeIssue() {
      // 构建一个包含对象 ID 的数组
      let idsArray = this.issueData.map(item => item.id);
      // 发送 POST 请求给后端
      this.http.post('/web/warehouse/purchase/detail/revokeIssue', idsArray)
        .then((res) => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch((error) => {
          this.utils.errorMessage(this.$t(error))
        });
    }

  }
};
</script>
